export enum ORG_URLS {
  BASE = 'organizations',
  OVERVIEW = 'overview',
  FUNDS_ENTITIES = 'funds-entities',
  COMPANIES = 'companies',
  DOCUMENTS = 'documents',
}

export enum ORG_URLS_FULL {
  OVERVIEW = ORG_URLS.BASE + '/' + ORG_URLS.OVERVIEW,
  FUNDS_ENTITIES = ORG_URLS.BASE + '/' + ORG_URLS.FUNDS_ENTITIES,
  COMPANIES = ORG_URLS.BASE + '/' + ORG_URLS.COMPANIES,
  DOCUMENTS = ORG_URLS.BASE + '/' + ORG_URLS.DOCUMENTS,
}
